import { useEffect, useState } from 'react';

import { getCookieForMembers } from '../../../src/client/utils/cookie-for-members';
import { useCookieContext } from '../../../src/client/contexts/cookie';
import browserUtils from '../../../src/client/utils/browser';

const REDIRECT_MODAL_STORAGE_KEY = 'redirect-existing-member-modal-key' as const;

const useRedirectExistingMemberModal = ({ modalWaitSeconds }: { modalWaitSeconds: number }) => {
  const serverCookieValue = useCookieContext() as string;
  const isMember = getCookieForMembers('health', { serverCookieValue })?.id !== undefined;

  const [isModalOpen, setModalIsOpen] = useState(false);
  const toggleModal = () => setModalIsOpen((open) => !open);

  useEffect(() => {
    const modalTimeout = setTimeout(() => {
      const { sessionStorage } = browserUtils.getWindow();
      const hasSeenModalInBrowserSession = sessionStorage.getItem(REDIRECT_MODAL_STORAGE_KEY) !== null;

      if (isMember && !hasSeenModalInBrowserSession) {
        setModalIsOpen(true);
        sessionStorage.setItem(REDIRECT_MODAL_STORAGE_KEY, 'seen');
      }
    }, modalWaitSeconds * 1000);

    return () => clearTimeout(modalTimeout);
  }, [isMember, modalWaitSeconds]);

  return { isModalOpen, toggleModal };
};

export default useRedirectExistingMemberModal;
